import { Link } from 'react-router-dom';
import { Shield, Twitter, Github, MessageCircle, ArrowUpRight } from 'lucide-react';

const LINKS = [
  {
    heading: 'Product',
    items: [
      { label: 'Wallet Scanner', href: '/dashboard/scanner' },
      { label: 'Scan History',   href: '/dashboard/history' },
      { label: 'API Access',     href: '/dashboard/api' },
      { label: 'Pricing',        href: '/pricing' },
    ],
  },
  {
    heading: 'Company',
    items: [
      { label: 'About',    href: '/about' },
      { label: 'Blog',     href: '/blog' },
      { label: 'Careers',  href: '/careers' },
      { label: 'Contact',  href: '/contact' },
    ],
  },
  {
    heading: 'Resources',
    items: [
      { label: 'Documentation', href: '/docs' },
      { label: 'API Reference', href: '/docs#scan-wallet' },
      { label: 'Status',        href: '/status' },
      { label: 'Changelog',     href: '/docs#changelog' },
    ],
  },
  {
    heading: 'Legal',
    items: [
      { label: 'Privacy Policy',   href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Security',         href: '/security' },
      { label: 'Cookie Policy',    href: '/cookies' },
    ],
  },
];

const SOCIAL = [
  { label: 'Twitter',  href: 'https://twitter.com', icon: Twitter },
  { label: 'GitHub',   href: 'https://github.com',  icon: Github },
  { label: 'Discord',  href: 'https://discord.com', icon: MessageCircle },
];

const Footer = () => (
  <footer className="border-t border-white/[0.06] bg-[#080c16]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-8">

      {/* Top: brand + links */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-14">

        {/* Brand column */}
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center gap-2.5 mb-4 group w-fit">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#00E5FF] to-[#7C3AED] flex items-center justify-center shadow-md">
              <Shield size={15} className="text-white" />
            </div>
            <span className="text-white font-bold text-sm">
              Zenith<span className="text-[#00E5FF]">Cipher</span>
            </span>
          </Link>
          <p className="text-slate-500 text-xs leading-relaxed mb-5 max-w-[180px]">
            Blockchain intelligence &amp; wallet risk analysis for Web3 teams.
          </p>
          <div className="flex items-center gap-2">
            {SOCIAL.map(({ label, href, icon: Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="w-8 h-8 rounded-lg bg-white/[0.05] hover:bg-[#00E5FF]/10 border border-white/[0.07] hover:border-[#00E5FF]/25 flex items-center justify-center text-slate-500 hover:text-[#00E5FF] transition-all"
              >
                <Icon size={14} />
              </a>
            ))}
          </div>
        </div>

        {/* Link columns */}
        {LINKS.map(({ heading, items }) => (
          <div key={heading}>
            <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-widest mb-4">
              {heading}
            </h3>
            <ul className="space-y-2.5">
              {items.map(({ label, href }) => (
                <li key={label}>
                  {href.startsWith('/') ? (
                    <Link
                      to={href}
                      className="text-xs text-slate-500 hover:text-slate-300 transition-colors"
                    >
                      {label}
                    </Link>
                  ) : (
                    <a
                      href={href}
                      className="text-xs text-slate-500 hover:text-slate-300 transition-colors inline-flex items-center gap-1"
                    >
                      {label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/[0.05] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-slate-600">
          &copy; {new Date().getFullYear()} ZenithCipher. All rights reserved.
        </p>
        <div className="flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
          <span className="text-xs text-slate-600">All systems operational</span>
        </div>
        <a
          href="https://etherscan.io"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 text-xs text-slate-600 hover:text-slate-400 transition-colors"
        >
          Powered by Etherscan <ArrowUpRight size={11} />
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
